/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Status_UncollectibleInputs */

const fr_payment_status_uncollectible = /** @type {(inputs: Payment_Status_UncollectibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échoué`)
};

/**

* @param {Payment_Status_UncollectibleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const payment_status_uncollectible = /** @type {((inputs?: Payment_Status_UncollectibleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Status_UncollectibleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_payment_status_uncollectible(inputs)
});